<template>
  <div>
    <slot></slot>
    <form
      v-if="ticketCartDetails"
      ref="boleto_auc"
      action="https://mpag.bb.com.br/site/mpag/"
      method="post"
      name="pagamento"
    >
      <input
        type="hidden"
        id="idConv"
        name="idConv"
        v-model="ticketCartDetails.ticketConfig.eCommerceCode"
      />
      <input
        type="hidden"
        id="refTran"
        name="refTran"
        v-model="ticketCartDetails.lastTicketReferenceCodeGeneratedString"
      />
      <input type="hidden" id="valor" name="valor" v-model="ticketCartDetails.formattedValue" />
      <input type="hidden" id="qtdPontos" name="qtdPontos" :value="0" />
      <input type="hidden" id="dtVenc" name="dtVenc" v-model="ticketCartDetails.dueDate" />
      <input type="hidden" id="tpPagamento" name="tpPagamento" value="21" />
      <input type="hidden" id="cpfCnpj" name="cpfCnpj" v-model="ticketCartDetails.person.cpf" />
      <input type="hidden" id="indicadorPessoa" name="indicadorPessoa" value="1" />
      <input
        type="hidden"
        id="tpDuplicata"
        name="tpDuplicata"
        v-model="ticketCartDetails.ticketType"
      />
      <input
        type="hidden"
        id="urlRetorno"
        name="urlRetorno"
        v-model="ticketCartDetails.ticketConfig.returningUrl"
      />
      <input
        type="hidden"
        id="urlInforma"
        name="urlInforma"
        v-model="ticketCartDetails.ticketConfig.informingUrl"
      />
      <input
        type="hidden"
        id="nome"
        name="nome"
        :value="ticketCartDetails.person.name + ' ' + ticketCartDetails.person.lastName"
      />
      <input
        type="hidden"
        id="endereco"
        name="endereco"
        v-model="ticketCartDetails.person.address.street"
      />
      <input
        type="hidden"
        id="cidade"
        name="cidade"
        v-model="ticketCartDetails.person.address.city"
      />
      <input type="hidden" id="uf" name="uf" v-model="ticketCartDetails.person.address.state" />
      <input type="hidden" id="cep" name="cep" v-model="ticketCartDetails.formattedPostalCode" />
      <input
        type="hidden"
        id="msgLoja"
        name="msgLoja"
        v-model="ticketCartDetails.ticketConfig.ticketMessage"
      />
      <input type="submit" value="Imprimir Boleto" class="bto-tb" style="display: none;" />
    </form>
  </div>
</template>

<script type="plain/text">
import TicketCartDetailsViewModel from "@/scripts/models/ticketCartDetailsViewModel.model";
import CommonHelper from "@/scripts/helpers/common.helper";
import { Routes } from "@/scripts/models/enums/routes.enum";
import CartService from "@/scripts/services/cart.service";
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import PaymentMethodProvider from "@/scripts/models/enums/paymentMethodProvider.enum";

export default {
  props: {
    loadFromPromise: Function
  },
  data() { 
    return {
      cartService: null,
      ticketCartDetails: new TicketCartDetailsViewModel(),
    };
  },
  computed: {
    ...mapGetters([
      "ticketCart",
      "cartSuccess",
      "campaignLandingPageConfig"
    ])
  },
  created() {
    this.setLandingPageConfig()
    this.cartService = new CartService(null);
    if(this.$route.query.cartId){
      this.cartService.getCartById(this.$route.query.cartId).then(function(cart){
        this.generateTicket(cart);
      }.bind(this))
    }
    else if (this.ticketCart) {
      var cart = this.ticketCart;      
      this.$store.commit("REMOVE_TICKET_CART");
      this.generateTicket(cart);
    } else {
      CommonHelper.swal(
        "",
        "Houve um problema ao gerar seu boleto, por favor entre em contato com o administrador.",
        "error"
      );
    }
  },
  methods: {
    ...mapActions([
      'setLandingPageConfig'
    ]),
    ticketCheckout(cart) {
      return this.cartService.ticketCheckout(cart);
    },
    generateTicketAgain(cart) {
      return this.cartService.generateTicketAgain(cart);
    },
    generateTicket(cart) {
      
      if (this.$route.query.again) {
        this.generateTicketAgain(cart).then(data => this.submitForm(data));
      } else {
        this.ticketCheckout(cart).then(data => this.submitForm(data));
      }
    },
    submitForm(ticketCartDetailsViewModel) {
      if (ticketCartDetailsViewModel.paymentMethodProvider === PaymentMethodProvider.PagarMe || ticketCartDetailsViewModel.paymentMethodProvider === PaymentMethodProvider.Asaas) {
        if(ticketCartDetailsViewModel.ticketUrl === null){
          window.location.reload();
          return;
        }

        const transactionCode = ticketCartDetailsViewModel.ticketCartDetails.transactionCode;
        const cart = ticketCartDetailsViewModel.cart;
        const paymentMethodProvider = ticketCartDetailsViewModel.paymentMethodProvider;
        const userId = ticketCartDetailsViewModel.person.userId;

        this.paymentRedirect(transactionCode, cart, paymentMethodProvider, cart.id);
        //window.location.href = ticketCartDetailsViewModel.ticketUrl;
      } else if (
        ticketCartDetailsViewModel.paymentMethodProvider === PaymentMethodProvider.PagSeguro ||
        ticketCartDetailsViewModel.paymentMethodProvider === PaymentMethodProvider.BancoBrasil
      ) {
        this.ticketCartDetails = ticketCartDetailsViewModel;
        Vue.nextTick(
          function() {
            this.$refs.boleto_auc.submit();
          }.bind(this)
        );
      }
    },
    // redirect checkout v1 congrats to checkout v2

    async paymentRedirect(transactionId, cart, paymentMethodProvider, cartId = null) {
      const transaction = await this.getTransaction(transactionId, paymentMethodProvider, cartId)
      transaction.total_amount = (transaction.total_amount/100)

      this.setLandingPageConfig();

      if (cart) {
        transaction.cart_id = cart.id;
      }

      this.$router.push({
        name: Routes.web.OrderApproved,
        query: { method: 'boleto' },
        params: { data: transaction },
      });
    },
async getTransaction(transactionId, paymentMethodProvider, cartId = null) {
      // 1. Começa com "or_" -> PagarMe V2
      if (transactionId.startsWith('or_')) {
        return await this.cartService.getPagarMeV2Transaction(transactionId);
      }

      // 2. Apenas números (Padrão PagarMe V1)
      const onlyNumbersRegex = /^\d+$/;
      if (onlyNumbersRegex.test(transactionId)) {
        return await this.cartService.getPagarMeV1Transaction(transactionId);
      }

      // 3. Caso contrário -> Asaas
      return await this.cartService.getAsaasTransaction(transactionId, cartId);
    }
  }
};
</script>

<style>
</style>
